// extracted by mini-css-extract-plugin
module.exports = {"rightSidebarWrapper":"rightSidebarWrapper__w4XKEFdECASG","chatPaneGroup":"chatPaneGroup__3bqWQ2aRPOEM"};